import React from 'react'
import { Link } from 'react-router-dom'
import { CheckCircleIcon } from '@heroicons/react/solid'

import classNames from '@/utils/classNamesLocal'

const plain = (html) => (html || '').replace(/<[^>]*>/g, '').trim()

// What a finished profile has. Order is roughly what a producer looks at
// first. Each item names the tab it lives on so the tabs can badge it.
const ITEMS = [
  { key: 'avatar', tab: 'profile', label: 'A profile picture', done: (u) => !!u.publicImageUrl && !/default|placeholder|missing/i.test(u.publicImageUrl) },
  { key: 'headline', tab: 'profile', label: 'A headline', done: (u) => plain(u.headline).length > 0 },
  { key: 'kinds', tab: 'profile', label: 'What kind of creator you are', done: (u) => (u.creatorKindsCount || 0) > 0 },
  { key: 'about', tab: 'profile', label: 'A bio', done: (u) => plain(u.description).length >= 40 },
  { key: 'links', tab: 'profile', label: 'At least one link', done: (u) => Object.values(u.socialLinks || {}).some((v) => v && v.trim()) },
  { key: 'demo', tab: 'work', label: 'A demo or sample', done: (u) => (u.demosCount || 0) > 0 },
  { key: 'tags', tab: 'work', label: 'Tags so search can find you', done: (u) => (u.labelingsCount || 0) > 0 },
  { key: 'rates', tab: 'work', label: 'Your rates', done: (u) => plain(u.pricing).length > 0 }
]

export const missingItems = (user) => ITEMS.filter((i) => !i.done(user))

const TAB_URL = { profile: '/profile', work: '/profile/work' }

const ProfileCompletion = ({ user }) => {
  const missing = missingItems(user)
  const done = ITEMS.length - missing.length
  const pct = Math.round((done / ITEMS.length) * 100)
  if (missing.length === 0) { return null }

  return <div className='rounded-xl bg-white p-4 shadow-sm dark:bg-gray-800'>
    <div className='flex flex-wrap items-center justify-between gap-2'>
      <div className='font-semibold text-gray-900 dark:text-white'>Your profile is {pct}% there</div>
      <div className='text-xs text-gray-500 dark:text-gray-400'>{done} of {ITEMS.length} done</div>
    </div>
    <div className='mt-2 h-2 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700'>
      <div className='h-full rounded-full bg-gradient-to-r from-cccpurple via-cccblue to-cccorange transition-[width]' style={{ width: `${pct}%` }} />
    </div>
    <ul className='mt-3 flex flex-wrap gap-2'>
      { ITEMS.map((i) => {
        const isDone = !missing.includes(i)
        const chip = <span className={classNames('inline-flex items-center gap-x-1 rounded-full px-2.5 py-1 text-xs font-semibold',
          isDone ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-100' : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600')}>
          { isDone && <CheckCircleIcon className='h-3.5 w-3.5' /> }{i.label}
        </span>
        return <li key={i.key}>{ isDone ? chip : <Link to={TAB_URL[i.tab]} className='hover:no-underline'>{chip}</Link> }</li>
      })}
    </ul>
  </div>
}

export default ProfileCompletion
